import React from 'react';
import { Link } from 'react-router-dom';

interface MentionTextProps {
  content: string;
  className?: string;
}

const MentionText: React.FC<MentionTextProps> = ({ content, className }) => {
  // Parse @mentions and render them as clickable links
  const renderContent = () => {
    if (!content) return null;

    // Match @username patterns
    const parts = content.split(/(@\w+)/g);
    
    return parts.map((part, index) => {
      if (part.startsWith('@')) {
        const username = part.slice(1);
        return (
          <Link
            key={index}
            to={`/profile/${username}`}
            className="text-primary font-medium hover:underline"
            onClick={(e) => e.stopPropagation()}
          >
            {part}
          </Link>
        );
      }
      return <span key={index}>{part}</span>;
    });
  };

  return <span className={className}>{renderContent()}</span>;
};

export default MentionText;
